import React, { useState } from 'react';
import uuid from 'uuid-random';
import DropDown from '@panel/commons/lib/DropDown';
import {
  Container,
  Content,
  LogoContainer,
  Logo,
  CardContainer,
  CardTitle,
  CardLinks,
  CardsCotainer,
  SocialMediaLink,
  IconSocial,
  SocialLinks,
  BottomFooterContainer,
  DropDownAcordion,
  HeaderContainter,
  Chevron,
  PortalLink,
  PortalLinkContainer,
  CardContent,
  BottomSeparator,
  Title
} from './styles';
import {
  footerLinks,
  socialMedia,
  appsLinks,
  legalLinks,
  fiscalQR,
  siteName,
  srcLogo
} from '../../../helpers/DataFooter/getDataFooter';
import BottomFooter from '../BottomFooter';

const Footer = ({ device }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <Container device={device} data-panel='landingZD-footer'>
      <Content data-panel='landingZD-footer-content' device={device}>
        <LogoContainer data-panel='landingZD-footer-locoContainer' device={device}>
          <Logo data-panel='landingZD-footer-logo' isOpen={dropdownOpen} src={srcLogo} device={device} />
        </LogoContainer>
        {device !== 'mobile' ? (
          <CardsCotainer device={device} data-panel='landingZD-footer-cardsLinks'>
            {footerLinks?.map(
              footerLink =>
                footerLink.title !== 'Fonoventas' && (
                  <CardContainer data-panel='landingZD-footer-linksContainer' key={uuid()}>
                    <CardTitle data-panel='landingZD-footer-linksContainer-title'>{footerLink.title}</CardTitle>
                    {footerLink.content.map(content => {
                      return !content.options ? (
                        <CardLinks
                          data-panel={`landingZD-footer-linksContainer-link-${content.controlPanel}`}
                          target='_blank'
                          href={content.link}
                          key={uuid()}
                        >
                          {content.wording}
                        </CardLinks>
                      ) : (
                        <CardContent
                          data-panel={`landingZD-footer-linksContainer-link-${content.controlPanel}`}
                          target='_blank'
                          href={content.link}
                          key={uuid()}
                        >
                          {content.wording}:
                          {content.options
                            ? content.options.map((portal, i) => {
                                return (
                                  <PortalLinkContainer key={portal.wording}>
                                    <PortalLink target='_blank' href={portal.link}>
                                      {portal.wording}
                                    </PortalLink>
                                    {i !== content.options.length - 1 && '·'}
                                  </PortalLinkContainer>
                                );
                              })
                            : null}
                        </CardContent>
                      );
                    })}
                    {footerLink.content2 && (
                      <>
                        <CardTitle marginTop data-panel='landingZD-footer-linksContainer-title'>
                          {footerLink.content2.title}
                        </CardTitle>
                        {footerLink.content2.content.map(content => (
                          <CardLinks
                            data-panel={`landingZD-footer-linksContainer-link-${content.controlPanel}`}
                            target='_blank'
                            href={content.link}
                            key={uuid()}
                          >
                            {content.wording}
                          </CardLinks>
                        ))}
                      </>
                    )}
                  </CardContainer>
                )
            )}
            <CardContainer data-panel='landingZD-footer-linksContainer'>
              <CardTitle data-panel='landingZD-footer-linksContainer-title' device={device}>
                {socialMedia?.title}
              </CardTitle>
              <SocialLinks data-panel='landingZD-footer-linksContainer-socialMedia' device={device}>
                {socialMedia?.content.map(socialNetwork => (
                  <SocialMediaLink
                    data-panel={`landingZD-footer-linksContainer-socialMedia-link-${socialNetwork.wording}`}
                    target='_blank'
                    key={uuid()}
                    device={device}
                    href={socialNetwork.link}
                  >
                    <IconSocial
                      src={socialNetwork.src}
                      data-panel={`landingZD-footer-linksContainer-socialMedia-icon-${socialNetwork.wording}`}
                    />
                  </SocialMediaLink>
                ))}
              </SocialLinks>
              <CardTitle data-panel='landingZD-footer-linksContainer-title' device={device}>
                {appsLinks?.title}
              </CardTitle>
              <SocialLinks device={device}>
                {appsLinks?.content.map(appLink => (
                  <SocialMediaLink
                    data-panel={`landingZD-footer-linksContainer-Apps-link-${appLink.wording}`}
                    target='_blank'
                    key={uuid()}
                    device={device}
                    href={appLink.link}
                  >
                    <IconSocial
                      src={appLink.src}
                      data-panel={`landingZD-footer-linksContainer-Apps-icon${appLink.wording}`}
                    />
                  </SocialMediaLink>
                ))}
              </SocialLinks>
            </CardContainer>
          </CardsCotainer>
        ) : null}
        <>
          {device !== 'desktop' ? (
            <DropDownAcordion data-panel='landingZD-footer-acordion' device={device}>
              {footerLinks?.map(footer => (
                <div key={uuid()}>
                  <DropDown
                    isOpen={dropdownOpen === footer.title}
                    setIsOpen={() => setDropdownOpen(dropdownOpen === footer.title ? null : footer.title)}
                    title={footer.title}
                    height={300}
                    headerComponent={React.createElement(
                      'div',
                      {},
                      <HeaderComponent title={footer.title} isOpen={dropdownOpen === footer.title} />
                    )}
                    dataPanel={footer.title}
                  >
                    {footer.content.map(content => {
                      return !content.options ? (
                        <CardLinks
                          data-panel={`landingZD-footer-acordion-DropDown-link${content.wording}`}
                          href={content.link}
                          key={uuid()}
                          device={device}
                          target='_blank'
                        >
                          {content.wording}
                        </CardLinks>
                      ) : (
                        <CardContent
                          data-panel={`landingZD-footer-linksContainer-link-${content.controlPanel}`}
                          target='_blank'
                          href={content.link}
                          key={uuid()}
                        >
                          {content.wording}:
                          {content.options
                            ? content.options.map((portal, i) => {
                                return (
                                  <PortalLinkContainer key={portal.wording}>
                                    <PortalLink target='_blank' href={portal.link}>
                                      {portal.wording}
                                    </PortalLink>
                                    {i !== content.options.length - 1 && '·'}
                                  </PortalLinkContainer>
                                );
                              })
                            : null}
                        </CardContent>
                      );
                    })}
                  </DropDown>
                  <BottomSeparator />
                </div>
              ))}
            </DropDownAcordion>
          ) : null}
          {device !== 'desktop' && (
            <CardContainer
              data-panel='landingZD-footer-linksContainer-cardContainer-apps'
              socialLinks={device !== 'desktop'}
              device={device}
            >
              <CardTitle data-panel='landingZD-footer-linksContainer-title' device={device}>
                {socialMedia?.title}
              </CardTitle>
              <SocialLinks device={device}>
                {socialMedia?.content.map(socialNetwork => (
                  <SocialMediaLink
                    data-panel='landingZD-footer-linksContainer-SocialMedia-link'
                    key={uuid()}
                    device={device}
                    href={socialNetwork.link}
                  >
                    <IconSocial src={socialNetwork.src} />
                  </SocialMediaLink>
                ))}
              </SocialLinks>
              <CardTitle data-panel='landingZD-footer-linksContainer-title' device={device}>
                {appsLinks?.title}
              </CardTitle>
              <SocialLinks device={device}>
                {appsLinks?.content.map(appLink => (
                  <SocialMediaLink
                    data-panel='landingZD-footer-linksContainer-Apps-link'
                    key={uuid()}
                    device={device}
                    href={appLink.link}
                  >
                    <IconSocial src={appLink.src} />
                  </SocialMediaLink>
                ))}
              </SocialLinks>
            </CardContainer>
          )}
        </>

        <BottomFooterContainer data-panel='landingZD-footer-BottomFooterContainer'>
          <BottomFooter
            data-panel='landingZD-footer-BottomFooter'
            siteNameCom={siteName}
            seeCompaniesLabel='Ver todas las empresas de'
            fiscalQR={fiscalQR}
            legalLinks={legalLinks && Object.values(legalLinks)}
            device={device}
          />
        </BottomFooterContainer>
      </Content>
    </Container>
  );
};

const HeaderComponent = ({ title, isOpen }) => {
  return (
    <HeaderContainter>
      <Title data-panel='landingZD-footer-acordion-dropDown-title'>{title}</Title>
      <Chevron isOpen={isOpen} data-panel='landingZD-footer-acordion-dropDown-title-footerChevron' />
    </HeaderContainter>
  );
};

export default Footer;
